module.exports = __webpack_public_path__ + "static/media/ehealth_lab_record_banner_desktop.00e5f3a9.jpg";